define('modules/admin/creatives/main',['require','T1Module'],function (require) {
  "use strict";

  const T1Module = require("T1Module");
  var instance;
  if (instance === undefined) {
    instance = new T1Module({
      name: "admin/creatives",
      viewCfgs: {
        components: {},
        "components-list": {}
      },
      defaultView: "components"
    });
  }
  return instance;
});
